import core_viz from './core-viz';
import love_hate_steps from './love-hate-steps';
import love_hate from './love-hate'
import track from './track';
import util from './_utils';
import filters from './filters';
import lang from './lang';

const timer = 3000;

let langInterval = null;

let skipTimeout;

const graphic_full = d3.select('.graphic__text-full'),
	graphic_right = d3.select('.graphic__right');

function init() {
	return new Promise((resolve, reject) => {
		util.changeVisibility(['.intro__step--1'], [true], [graphic_full]);

		d3.selectAll('.skip-intro').on('click', skip);
		d3.selectAll('.intro-button__next').on('click', next);

		resolve()
	})
}

function next(index = undefined) {
	$('.graphic').unbind('scroll');
	$('.graphic').unbind('mousewheel');

	const el = this ? d3.select(this) : null;
	index = index == undefined ? +el.attr('data-index') : index;

	if (index > 0) {
		d3.select('.bottom-ui--start').classed('is-visible', false);
		d3.selectAll('.skip-intro').classed('is-adjusted', false);
	}

	if (index == 1) {
		// d3.select('.skip-intro').style('pointer-events', 'none');
		core_viz.moveMass('fullCenter', true);
		skipStep(2, 4000);
	} else if (index == 2) {
		skipStep(3, 4000);
	}

	if (index == 3) {
		d3.select('.bottom-ui--ready').classed('is-visible', true);
		d3.selectAll('.skip-intro').classed('is-adjusted', true);
	} else {
		d3.select('.bottom-ui--ready').classed('is-visible', false);
		d3.selectAll('.skip-intro').classed('is-adjusted', false);
	}

	if (index == 4) {
		endLangTransition();
		love_hate.next(0);
		track.next(0);
		love_hate_steps.init();
		d3.selectAll('.skip-intro').classed('is-adjusted', true);
	} else {
		graphic_full.select(`[data-step='${index}']`).classed('is-past', true);
		util.changeVisibility([`[data-step='${index}']`, `[data-step='${index + 1}']`], [false, true], [graphic_full, graphic_full]);
	};
}

function skipStep(index, dur) {
	skipTimeout = setTimeout(() => {
		graphic_full.select(`[data-step='${index}']`).classed('is-past', true);
		util.changeVisibility([`[data-step='${index}']`, `[data-step='${index + 1}']`], [false, true], [graphic_full, graphic_full]);
		next(index)

		if (index == 3) {
			d3.select('.skip-intro').style('pointer-events', 'all');
			core_viz.moveMass('outOfView', false);
			core_viz.updateMassRadius('real')
			track.init();
			love_hate.next(-1);

			$('.graphic').bind('scroll', function(evt) {
				next(4);
			}).bind('mousewheel', function(evt) {
				next(4);
			});
		}
	}, dur)
}

function skip() {
	util.changeHeader('.landing-header', '.main-header');
	util.changeVisibility(['.intro__step'], [false]);

	d3.selectAll('.intro-step').classed('is-past', true);
	clearTimeout(skipTimeout);

	end();
}

function jumpTo(index, fromMenu = false) {
	for (let i = 0; i < index; i++) {
		graphic_full.select(`[data-step='${i}']`).classed('is-past', true).classed('is-visible', false);
	}

	for (let i = index; i < 4; i++) {
		graphic_full.select(`[data-step='${i}']`).classed('is-past', false).classed('is-visible', false);
	}

	graphic_full.select(`[data-step='${index}']`).classed('is-past', false).classed('is-visible', true);
}

function end() {
	$('.graphic').unbind('scroll');
	$('.graphic').unbind('mousewheel');
	endLangTransition();

	graphic_full.select(`[data-step='${3}']`).classed('is-past', true);

	util.changeVisibility([`[data-step='${3}']`], [false], [graphic_full]);
	util.showChapter('core-viz')

	core_viz.updateMassRadius('real');
	core_viz.massMouseoverOn(1000, true);
	core_viz.moveMass('center', false);

	setTimeout(() => {
		core_viz.setupMouseoverButtons()
	}, 2000);

	filters.toggle('core-viz', -1);
}

function startLangTransition() {
	const langText = $('.change-language'),
		langCount = langText.length;

	let i = 2;

	langInterval = setInterval(function() {
		if (i >= langCount) i = 1;

		langText.each(function() {
			const thisLang = $(this),
				thisLangIndex = thisLang.index();

			thisLang.toggleClass('is-visible', thisLangIndex === i);
		});

		i++;

	}, 3000);
}

function endLangTransition() {
	clearInterval(langInterval);
	const selectedLang = lang.getCurrentLang();
	d3.selectAll(`.change-language`).classed('is-visible', false)
	d3.selectAll(`.change-language.lang--${selectedLang}`).classed('is-visible', true)
}

export default {
	init,
	next,
	skip,
	jumpTo,
	end,
	startLangTransition,
	endLangTransition,
};